import React, { Component } from 'react';
import { arrayOf, bool, func } from 'prop-types';
import { connect } from 'react-redux';

import AppPanel from 'components/panels/AppPanel';
import HistoryPanel from 'components/panels/HistoryPanel';
import HistoryType from 'types/HistoryType';
import RoutePaths from 'constants/RoutePaths';

import { requestedHistoryAction, requestedDeleteHistoryAction } from 'actions/dataActions';

import { requestedNavigationAction } from 'actions/routerActions';

import { closeAppPanel, closeHistoryPanel } from 'actions/uiActions';

import { appPanelVisibilitySelector, historyPanelVisibilitySelector } from 'selectors/uiSelectors';

import { historyDataSelector } from 'selectors/dataSelectors';

class PanelContainer extends Component {
    constructor() {
        super();
        this.handleHistoryClick = this.handleHistoryClick.bind(this);
    }

    handleHistoryClick({ keyword, platformId, locationId }) {
        this.props.onCloseHistoryPanel();
        this.props.requestNavigation(RoutePaths.DASHBOARD, {
            keyword,
            locationId,
            platformId,
        });
    }

    render() {
        return (
            <div>
                <AppPanel onClose={this.props.onCloseAppPanel} visible={this.props.appPanelVisible} />
                <HistoryPanel
                    data={this.props.historyData}
                    fetching={this.props.fetchingHistoryData}
                    onClick={this.handleHistoryClick}
                    onClose={this.props.onCloseHistoryPanel}
                    onOpen={this.props.requestHistoryFetch}
                    onDeleteHistory={this.props.requestHistoryDelete}
                    visible={this.props.historyPanelVisible}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    appPanelVisible: appPanelVisibilitySelector(state),
    fetchingHistoryData: state.history.fetching,
    historyData: historyDataSelector(state),
    historyPanelVisible: historyPanelVisibilitySelector(state),
});

const mapDispatchToProps = dispatch => ({
    onCloseAppPanel() {
        dispatch(closeAppPanel());
    },
    onCloseHistoryPanel() {
        dispatch(closeHistoryPanel());
    },
    requestNavigation(route, params) {
        dispatch(requestedNavigationAction(route, params));
    },
    requestHistoryFetch() {
        dispatch(requestedHistoryAction());
    },
    requestHistoryDelete() {
        dispatch(requestedDeleteHistoryAction());
    },
});

PanelContainer.propTypes = {
    appPanelVisible: bool.isRequired,
    fetchingHistoryData: bool.isRequired,
    historyData: arrayOf(HistoryType).isRequired,
    historyPanelVisible: bool.isRequired,
    onCloseAppPanel: func.isRequired,
    onCloseHistoryPanel: func.isRequired,
    requestHistoryFetch: func.isRequired,
    requestNavigation: func.isRequired,
    requestHistoryDelete: func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(PanelContainer);
